import styled, { css } from "styled-components";

export const MapRoot = styled.div(
    ({ theme }) => css`
        overflow: hidden;
        width: 100%;
        border-radius: ${theme.borderRadiusLg};
        --map-height: 14rem;
        height: var(--map-height);
        iframe {
            width: 100%;
            height: calc(var(--map-height) + 76px);
            margin-top: -60px;
            border-radius: ${theme.borderRadiusLg};
        }
    `,
);
